import styled from '@emotion/styled';
import {
    Fragment,
    RefObject, useEffect, useState,
} from 'react';

interface Props {
    containerRef: RefObject<HTMLDivElement|null>;
  containerHeight: number;
}

const THUMB_HEIGHT = 70;

function ScrollBar({ containerRef, containerHeight }:Props) {
    // const [containerHeight, setContainerHeight] = useState(0);
    const [transform, setTransform] = useState<number>(0);
    const [isVisible, setIsVisible] = useState<boolean>(false);
    useEffect(() => {
        const onScroll = () => {
            const { scrollHeight, offsetHeight, scrollTop } = containerRef.current!;
            const percent = (scrollTop) / (scrollHeight - offsetHeight);
            setTransform(percent * (containerHeight - THUMB_HEIGHT * 1.5));
            setIsVisible(scrollHeight > offsetHeight);
        };
        if (containerRef.current) {
            // setContainerHeight(containerRef.current.offsetHeight);
            containerRef.current.addEventListener('scroll', onScroll);
        }
        onScroll();
        return () => containerRef.current?.removeEventListener('scroll', onScroll);
    }, [containerRef, containerHeight]);
    /*
  useEffect(() => {
    const onResize = () => {
      if (containerRef.current) {
        setContainerHeight(containerRef.current.offsetHeight);
      }
    };
    onResize();
    window.addEventListener('resize', onResize);
    containerRef.current?.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      containerRef.current?.removeEventListener('resize', onResize);
    };
  }, [containerRef]);

   */
    if (isVisible) {
        return (
            <Track>
                <Thumb style={{ transform: `translateY(${transform}px)` }}
                />
            </Track>
        );
    }
    return <Fragment/>;
}

const Track = styled.div`
    background-color: rgba(255, 255, 255, 0.24);
    border-radius: 10px;
    height: calc(100% - 40px);
    position: absolute;
    right: 14px;
    top: 20px;
    width: 10px;
`;

const Thumb = styled.div`
    background-color: var(--color-white);
    border-radius: 10px;
    height: 70px;
    width: 100%;
`;

export default ScrollBar;
